import { ArrowUpRight, Lock, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { generateApiKey } from "../../../helpers/common.helpers";
import axios from "axios";
import { useState } from "react";
import LockedCard from "./LockedCard";
import FeedbackForm from "./Navbar/FeedbackForm";
import { useMutation } from "@tanstack/react-query";
import { updateUserFeedbackCountServices } from "../../../services/users.services";


// Custom Card Components
const Card = ({ children, className = "", onClick, ...props }) => {
  return (
    <div
      className={`rounded-lg border border-gray-200 bg-white text-gray-950 shadow-sm ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

const CardContent = ({ children, className = "" }) => {
  return <div className={`${className}`}>{children}</div>;
};

// Locked Card Component
// Locked Card Component
// Locked Card Component

const CourseGrid = () => {
  const navigate = useNavigate();
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [shouldCallApiAfterFeedback, setShouldCallApiAfterFeedback] = useState(false);
  const [loading, setLoading] = useState(false);


  // Check localStorage for lock state
  const isLocked = localStorage.getItem("status") !== "active";
  const batch = Number(localStorage.getItem("batch_id"));
  const program_inclusion_pid = Number(localStorage.getItem("program_id"));
  const category_id = Number(localStorage.getItem("category"));
  const term = Number(localStorage.getItem("term"));
  const categoryMap = [24, 22, 18, 27, 4];
  const batchMap = [91, 90, 84, 103, 110, 121, 123];
  const programMap = [42, 43, 60, 61, 63, 69, 72, 75, 79, 88, 92, 102];

  const fetchthinficurl = async () => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "page-index": generateApiKey(),
        },
        url: `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/dashboardhomepage/fetch_thinkific_url`,
        data: {
          email: localStorage.getItem("email"),
          firstname: localStorage.getItem("username"),
          lastname: localStorage.getItem("lastname"),
        },
      });
      let url = response.data;
      if (Array.isArray(url)) {
        url = url[0]?.url || url[0]?.sso_url || url[0]?.link || url[0];
      } else if (typeof url === 'object' && url !== null) {
        url = url.url || url.sso_url || url.link;
      }
      
      if (typeof url === 'string' && url.startsWith('http')) {
        window.open(url, "_blank");
      } else {
        console.error("Invalid Thinkific URL format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching Thinkific URL:", error);
    }
  };

  const { mutate: updateUserFeedBackCount } = useMutation({
    mutationFn: ({ userId }) =>
      updateUserFeedbackCountServices({ userId }),
    onSuccess: (data) => {
      // queryClient.invalidateQueries(["acknowledgment-status"]);
      // setOpen(false);
      console.log(data)
      localStorage.setItem("feedback_count", data.feedback_count);
    },
    onError: (error) => {
      console.error("Error updating acknowledgment status:", error);
    }
  });


  const checkEmailInGoogleSheets = async () => {
    try {
      // const feedbackCount = localStorage.getItem("dashboardFeedBackCount") || 0
      const backendFeedbackCount = Number(localStorage.getItem("feedback_count")) || 0
      const dashboardFeedBackCount = Number(localStorage.getItem("dashboardFeedBackCount")) || 0;
      const dashboardFeedbackStatus = Number(localStorage.getItem("dashboardFeedbackStatus")) || 0;
      // const userEmail = localStorage.getItem("email");
      // updateUserFeedBackCount({ userId: localStorage.getItem("user_id") });
      // const res = await fetch(
      //   "https://script.google.com/macros/s/AKfycbw101VUPZ28IEdK-X6fZFLukOn4Lrkp5Av0Zus5aiVurzgFBqvunskYNQBQhfOWhs2P/exec"
      // );
      // const data = await res.json();
      // const emailRecord = data.emailData.find(item => item.email === userEmail);


      if (dashboardFeedbackStatus === 1) {
        return true
      } else if (dashboardFeedBackCount > 1) {
        return true
      } else if (backendFeedbackCount >= 3) {
        return true
      } else {
        return false
      }


      // if (feedbackCount > 3 || backendFeedbackCount > 3) {
      //   return true
      // } else ifelse if (feedbackCount <= 3) {

      //   if (emailRecord) {
      //     return true;
      //   } else {

      //     return false;
      //   }
      // } else {
      //   return true
      // }

    } catch (error) {
      console.error("Error checking email in Google Sheets:", error);
      // If there's an error checking, assume email doesn't exist and show feedback
      return false;
    }

  };


  const handleMyCoursesClick = async () => {
    const dashboardFeedBackCount = localStorage.getItem("dashboardFeedBackCount") || 0;
    localStorage.setItem("dashboardFeedBackCount", Number(dashboardFeedBackCount) == 0 ? 1 : Number(dashboardFeedBackCount) + 1);
    if (loading) return; // Prevent multiple clicks

    setLoading(true);
    try {
      // Check if email exists in Google Sheets
      const emailExists = await checkEmailInGoogleSheets();
      if (emailExists) {
        // Email exists, directly call the API
        await fetchthinficurl();
      } else {
        // Email doesn't exist, show feedback modal first
        // const feedbackCount = localStorage.getItem("dashboardFeedBackCount") || 0
        // console.log(feedbackCount)
        // if (feedbackCount > 3) {
        //   await fetchthinficurl()
        //   setShowFeedbackModal(false);
        // } else {
        // localStorage.setItem("dashboardFeedBackCount", Number(feedbackCount) + 1)
        updateUserFeedBackCount({ userId: localStorage.getItem("user_id") });
        setShouldCallApiAfterFeedback(true)
        setShowFeedbackModal(true);
        // }
        // setShowFeedbackModal(true);
      }
    } finally {
      setLoading(false);
    }
  };


  const handleFeedbackClose = async () => {
    console.log("Feedback modal closed");
    setShowFeedbackModal(false);


    // If we need to call the API after feedback, do it now
    if (shouldCallApiAfterFeedback) {
      console.log("Calling API after feedback submission");
      setShouldCallApiAfterFeedback(false);
      await fetchthinficurl();
    }
  };


  const handleCardClick = () => {
    console.log("Clicked");
    navigate("/CareerCounselling");
  };

  const handleEventsClick = () => {
    console.log("Clicked Events");
    const newemail = btoa(localStorage.getItem("email"));
    window.open(`https://calendar.accredian.com/${newemail}`, "_blank");
  };

  // Icon components
  const CoursesIcon = (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      className={isLocked ? "text-gray-400" : "text-blue-500"}
    >
      <path
        d="M12 2L3 7L12 12L21 7L12 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 17L12 22L21 17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12L12 17L21 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const EventsIcon = (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      className={isLocked ? "text-gray-400" : "text-blue-500"}
    >
      <rect
        x="3"
        y="4"
        width="18"
        height="18"
        rx="2"
        ry="2"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        x1="16"
        y1="2"
        x2="16"
        y2="6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="8"
        y1="2"
        x2="8"
        y2="6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="3"
        y1="10"
        x2="21"
        y2="10"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle cx="8" cy="14" r="1" fill="currentColor" />
      <circle cx="12" cy="14" r="1" fill="currentColor" />
      <circle cx="16" cy="18" r="1" fill="currentColor" />
    </svg>
  );

  const CareerIcon = (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      className={isLocked ? "text-gray-400" : "text-blue-500"}
    >
      <path
        d="M22 12H18L15 21L9 3L6 12H2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="12"
        r="3"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
    </svg>
  );

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
        {/* My Courses Card */}
        {isLocked ? (
          <>
            <LockedCard tooltipText="Complete your profile to unlock courses">
              <Card
                onClick={handleMyCoursesClick}
                className="relative overflow-hidden bg-white border-0 shadow-xl hover:shadow-xl transition-all duration-300 cursor-pointer group"
                id="tour-go-to-lms"
              >
                {/* Loading Overlay */}
                {loading && (
                  <div className="absolute inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center">
                    <div className="flex flex-col items-center gap-3">
                      <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
                      <p className="text-sm font-medium text-blue-600">Please wait while we load your course</p>
                    </div>
                  </div>
                )}

                <CardContent className="p-4">
                  <div className="absolute top-6 right-6">
                    <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-blue-600 transition-colors" />
                  </div>
                  <div className="flex items-start gap-4 mb-0">
                    <div className="relative flex-shrink-0">
                      <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center group-hover:scale-105 transition-transform">
                        {CoursesIcon}
                      </div>
                    </div>
                    <div className="flex-1 space-y-4">
                      <div>
                        <h3 className="text-xl font-bold text-slate-800">
                          Go To LMS
                        </h3>
                        <p className="text-slate-500 text-sm mt-2">
                          Access your class recordings, study materials, and assignments.
                        </p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </LockedCard>

            <LockedCard tooltipText="Complete your profile to unlock courses">
              <Card
                onClick={handleEventsClick}
                className="relative overflow-hidden bg-white border-0 shadow-xl hover:shadow-xl transition-all duration-300 cursor-pointer group"
                id="tour-event-calendar"
              >
                <CardContent className="p-4">
                  <div className="absolute top-6 right-6">
                    <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-blue-600 transition-colors" />
                  </div>
                  <div className="flex items-start gap-4 mb-0">
                    <div className="relative flex-shrink-0">
                      <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center group-hover:scale-105 transition-transform">
                        {EventsIcon}
                      </div>
                    </div>
                    <div className="flex-1 space-y-4">
                      <div>
                        <h3 className="text-xl font-bold text-slate-800 mb-1">
                          Events
                        </h3>
                        <p className="text-slate-500 text-sm">
                          Upcoming sessions & workshops
                        </p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </LockedCard>


            <LockedCard tooltipText="Complete your profile to unlock courses">
              <Card
                className="relative overflow-hidden bg-white border-0 shadow-xl hover:shadow-xl transition-all duration-300 cursor-pointer group"
                onClick={handleCardClick}
                id="tour-career-counselling"
              >
                <CardContent className="p-4">
                  <div className="absolute top-6 right-6">
                    <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-blue-600 transition-colors" />
                  </div>
                  <div className="flex items-start gap-4 mb-0">
                    <div className="relative flex-shrink-0">
                      <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center group-hover:scale-105 transition-transform">
                        {CareerIcon}
                      </div>
                    </div>
                    <div className="flex-1 space-y-4">
                      <div>
                        <h3 className="text-xl font-bold text-slate-800 mb-1">
                          Career Counselling
                        </h3>
                        <p className="text-slate-500 text-sm">
                          Book 1-on-1 mentorship sessions and get expert resume guidance.
                        </p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </LockedCard>
          </>
        ) : (
          <>
            <Card
              onClick={handleMyCoursesClick}
              className="relative overflow-hidden bg-white border-0 shadow-xl hover:shadow-xl transition-all duration-300 cursor-pointer group"
              id="tour-go-to-lms"
            >
              {/* Loading Overlay */}
              {loading && (
                <div className="absolute inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center">
                  <div className="flex flex-col items-center gap-3">
                    <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
                    <p className="text-sm font-medium text-blue-600">Please wait while we load your course</p>
                  </div>
                </div>
              )}

              <CardContent className="p-4">
                <div className="absolute top-6 right-6">
                  <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-blue-600 transition-colors" />
                </div>
                <div className="flex items-start gap-4 mb-0">
                  <div className="relative flex-shrink-0">
                    <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center group-hover:scale-105 transition-transform">
                      {CoursesIcon}
                    </div>
                  </div>
                  <div className="flex-1 space-y-4">
                    <div>
                      <h3 className="text-xl font-bold text-slate-800">
                        Go To LMS
                      </h3>
                      <p className="text-slate-500 text-sm mt-2">
                        Access your class recordings, study materials, and assignments.
                      </p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>


            <Card
              onClick={handleEventsClick}
              className="relative overflow-hidden bg-white border-0 shadow-xl hover:shadow-xl transition-all duration-300 cursor-pointer group"
              id="tour-event-calendar"
            >
              <CardContent className="p-4">
                <div className="absolute top-6 right-6">
                  <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-blue-600 transition-colors" />
                </div>
                <div className="flex items-start gap-4 mb-0">
                  <div className="relative flex-shrink-0">
                    <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center group-hover:scale-105 transition-transform">
                      {EventsIcon}
                    </div>
                  </div>
                  <div className="flex-1 space-y-4">
                    <div>
                      <h3 className="text-xl font-bold text-slate-800 mb-1">
                        Event Calendar
                      </h3>
                      <p className="text-slate-500 text-sm">
                        View your upcoming live sessions & masterclasses.
                      </p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
            {term > 3 ||
              (categoryMap.includes(category_id) &&
                batchMap.includes(batch) &&
                programMap.includes(program_inclusion_pid)) ? (
              <Card
                className="relative overflow-hidden bg-white border-0 shadow-xl hover:shadow-xl transition-all duration-300 cursor-pointer group"
                onClick={handleCardClick}
                id="tour-career-counselling"
              >
                <CardContent className="p-4">
                  <div className="absolute top-6 right-6">
                    <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-blue-600 transition-colors" />
                  </div>
                  <div className="flex items-start gap-4 mb-0">
                    <div className="relative flex-shrink-0">
                      <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center group-hover:scale-105 transition-transform">
                        {CareerIcon}
                      </div>
                    </div>
                    <div className="flex-1 space-y-4">
                      <div>
                        <h3 className="text-xl font-bold text-slate-800 mb-1">
                          Career Counselling
                        </h3>
                        <p className="text-slate-500 text-sm">
                          Book 1-on-1 mentorship sessions and get expert resume guidance.
                        </p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ) : (
              <LockedCard tooltipText="Career Counselling Activates after term 3">
                <Card
                  className="relative overflow-hidden bg-white border-0 shadow-xl hover:shadow-xl transition-all duration-300 cursor-pointer group"
                  onClick={handleCardClick}
                  id="tour-career-counselling"
                >
                  <CardContent className="p-4">
                    <div className="absolute top-6 right-6">
                      <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-blue-600 transition-colors" />
                    </div>
                    <div className="flex items-start gap-4 mb-0">
                      <div className="relative flex-shrink-0">
                        <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center group-hover:scale-105 transition-transform">
                          {CareerIcon}
                        </div>
                      </div>
                      <div className="flex-1 space-y-4">
                        <div>
                          <h3 className="text-xl font-bold text-slate-800 mb-1">
                            Career Counselling
                          </h3>
                          <p className="text-slate-500 text-sm">
                            Book 1-on-1 mentorship sessions and get expert resume guidance.
                          </p>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </LockedCard>
            )}
          </>
        )}
      </div>
      {/* Feedback Modal */}
      {showFeedbackModal && (
        <FeedbackForm onClose={handleFeedbackClose} />
      )}
    </>
  );
};

export default CourseGrid;
